/* eslint-disable array-callback-return */
import React, { Component } from "react";
import jwt from "../../services/jwt";
import { Button, notification, Modal } from "antd";
import { PoweroffOutlined } from "@ant-design/icons";
import Inputlayer from "./../../components/FormComponent/Input";
import {
  loginSchema,
  forgotSchema,
  resetpasswordSchema,
  formotpData,
} from "./../../schema/login";
import postService from "./../../services/httpService";
import networkList from "./../../constants/networkList";
import Storage from "./../../services/local-store";
import * as R from "ramda";
import logo from "../../assets/images/Bitmap.png";
import Footer from "../../shell/footer";
import "./login.css";
const { login } = networkList;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      error: null,
      visible: false,
      loading: false,
      user_id: "",
      isShow: false,
      timer: 60,
    };
  }

  componentDidMount() {
  
    if (Storage.get("token") === null || Storage.get("token") === undefined) {
      Storage.clearAll();
    } else {
      this.gotoDasahboard();
    }
    this.date();
    let formSchema = Object.assign({}, forgotSchema);
    formSchema["feilds"].map((feild, key) => {
      formSchema["feilds"][key]["value"] = null;
      formSchema["feilds"][key]["valid"] = false;
      formSchema["feilds"][key]["errors"] = [];
      delete formSchema["feilds"][key]["text"];
    });
    this.setState({ formData: formSchema["feilds"] });
    // otp formdata
    let formotData = Object.assign({}, formotpData);
    formotData["feilds"].map((feild, key) => {
      formotData["feilds"][key]["value"] = null;
      formotData["feilds"][key]["valid"] = false;
      formotData["feilds"][key]["errors"] = [];
      delete formotData["feilds"][key]["text"];
    });
    this.setState({ formotpData: formotData["feilds"] });
    // reset passworddata
    let resetpassword = Object.assign({}, resetpasswordSchema);
    resetpassword["feilds"].map((feild, key) => {
      resetpassword["feilds"][key]["value"] = null;
      resetpassword["feilds"][key]["valid"] = false;
      resetpassword["feilds"][key]["errors"] = [];
      delete resetpassword["feilds"][key]["text"];
    });
    this.setState({ resetpassword: resetpassword["feilds"] });
    this.ShowresendWithDelay();
    this.interval = setInterval(
      () => this.setState((prevState) => ({ timer: prevState.timer - 1 })),
      1000
    );
  }

  componentDidUpdate() {
    if (this.state.timer === 1) {
      clearInterval(this.interval);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  login() {
    // Storage.store("token", "123");
    // this.props.history.push(`/token-generator`);
    // return;
    var validData = [];
    loginSchema.feilds.filter((data, key) => {
      if (data["element"] === "input" && !data.valid && data.required) {
        validData.push(false);
        this.validateFeilds(data);
      }
    });
    if (!validData.includes(false)) {
      this.setState({ loading: true });
   
      let usernameobj = R.find(R.propEq("name", "userid"))(loginSchema.feilds);
      let passwordobj = R.find(R.propEq("name", "password"))(loginSchema.feilds);

      if (!R.isNil(usernameobj) && !R.isNil(passwordobj)) {
        
        let obj = {
          username: usernameobj.value,
          password: passwordobj.value,
        };
       postService(login, "POST", obj).then((res) => {
         if (res.status) {
            Storage.store("token", res.token);
            Storage.store("all_tokens", res.all_tokens);
            Storage.store("user", res.rows[0].username);
            Storage.store("user_data", res.rows[0]);
            Storage.store("all_user_data", res.rows);
            Storage.store("role", res.rows[0].role_name);
            Storage.store("id", res.rows[0].id);
            this.gotoDasahboard();
          } else {
            this.setState({ loading: false });
            Modal.error({
              title: "Error!",
              content: "Invalid Credentials",
            });
          }
        });
      }
    }
  }

  sendOTP = () => {
    const { sendOTP } = networkList;
    var formFeilds = this.state.formData;
    let errors = this.validateModalFeilds(formFeilds);
    this.setState({
      user_name: this.state.user_id ? this.state.user_id : formFeilds[1].value,
    });
    // console.log('username:', formFeilds[1].value)
    if (!errors.includes(false)) {
      this.setState(
        (state) => ({ btnloading: true }),
        () => {
          postService(sendOTP, "POST", {
            data: {
              username: this.state.user_name,
            },
          }).then((res) => {
            if (res.status) {
              // alert('Data inserted');
              // console.log('res:', res)
              this.setState((state) => ({
                user_id: res.user_id,
                getusername: res.username,
                mobile: res.mobile,
                btnloading: false,
                visible: false,
              }));
              // Modal.success({
              //     title: 'Success',
              //     content: "Successfully Updated",
              // });
              notification.success({
                message: "Success",
                description: res.message,
                duration: 10,
                top: 20,
                right: 0,
              });
              this.otpmodal();
            } else {
              // alert('Data not inserted');
              this.setState({ btnloading: false });
              // Modal.error({
              //     title: 'Failure',
              //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
              // });
              notification.error({
                message: "Failure",
                description: res.message
                  ? res.message
                  : "Oops! something went wrong... Please try again.",
                duration: 10,
                top: 20,
                right: 0,
              });
            }
          });
        }
      );
      let formSchema = Object.assign({}, forgotSchema);
      formSchema["feilds"].map((feild, key) => {
        formSchema["feilds"][key]["value"] = null;
        formSchema["feilds"][key]["valid"] = false;
        formSchema["feilds"][key]["errors"] = [];
        delete formSchema["feilds"][key]["text"];
      });
      this.setState({ formData: formSchema["feilds"] });
    }
  };

  resendOTP = () => {
    const { sendOTP } = networkList;
    try {
      this.setState(
        (state) => ({ btnloading: true }),
        () => {
          postService(sendOTP, "POST", {
            data: {
              username: this.state.getusername,
            },
          }).then((res) => {
            if (res.status) {
              // alert('Data inserted');
            
              this.setState((state) => ({
                user_id: res.user_id,
                getusername: res.username,
                mobile: res.mobile,
                btnloading: false,
                visible: false,
                isShow: false,
                timer: 60,
              }));
              // Modal.success({
              //     title: 'Success',
              //     content: "Successfully Updated",
              // });
              notification.success({
                message: "Success",
                description: res.message,
                duration: 10,
                top: 20,
                right: 0,
              });
              this.otpmodal();
              this.interval = setInterval(
                () =>
                  this.setState((prevState) => ({
                    timer: prevState.timer - 1,
                  })),
                1000
              );
              this.ShowresendWithDelay();
            } else {
              // alert('Data not inserted');
            
              this.setState({ btnloading: false });
              // Modal.error({
              //     title: 'Failure',
              //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
              // });
              notification.error({
                message: "Failure",
                description: res.message
                  ? res.message
                  : "Oops! something went wrong... Please try again.",
                duration: 10,
                top: 20,
                right: 0,
              });
            }
          });
        }
      );
    } catch (error) {
    
      Modal.error({
        title: "Failure",
        content: "Oops, something went wrong... Please try again.",
      });
    }
  };

  checkOTP = () => {
    const { checkOTP } = networkList;
    var formFeilds = this.state.formotpData;
    let errors = this.validateModalFeilds(formFeilds);
    this.setState({
      otp: formFeilds[1].value,
    });
    // console.log('formotpData:', formFeilds[1].value)
    if (!errors.includes(false)) {
      this.setState(
        (state) => ({ btnloading: true }),
        () => {
          postService(checkOTP, "POST", {
            data: {
              otp: this.state.otp,
              user_id: this.state.user_id,
            },
          }).then((res) => {
            if (res.status) {
              // alert('Data inserted');
              // console.log('res:', res)
              this.setState((state) => ({ btnloading: false, visible: false }));
              // Modal.success({
              //     title: 'Success',
              //     content: "Successfully Updated",
              // });
              notification.success({
                message: "Success",
                description: res.message,
                duration: 10,
                top: 20,
                right: 0,
              });
              this.otpmodalcancel();
              this.passwordmodal();
            } else {
              // alert('Data not inserted');
              // console.log('fail res:', res)
              this.setState({ btnloading: false });
              // Modal.error({
              //     title: 'Failure',
              //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
              // });
              notification.error({
                message: "Failure",
                description: res.message
                  ? res.message
                  : "Oops! something went wrong... Please try again.",
                duration: 10,
                top: 20,
                right: 0,
              });
            }
          });
        }
      );
      let formotData = Object.assign({}, formotpData);
      formotData["feilds"].map((feild, key) => {
        formotData["feilds"][key]["value"] = null;
        formotData["feilds"][key]["valid"] = false;
        formotData["feilds"][key]["errors"] = [];
        delete formotData["feilds"][key]["text"];
      });
      this.setState({ formotpData: formotData["feilds"] });
    }
  };

  updatePassword = () => {
    const { updatePassword } = networkList;
    var formFeilds = this.state.resetpassword;
    let errors = this.validateModalFeilds(formFeilds);
    this.setState({
      confirm_password: formFeilds[2].value,
    });
    // console.log('updatePassword:', formFeilds[2].value)
    if (!errors.includes(false)) {
      if (formFeilds[1].value === formFeilds[2].value) {
        this.setState(
          (state) => ({ btnloading: true }),
          () => {
            postService(updatePassword, "POST", {
              data: {
                password: this.state.confirm_password,
                user_id: this.state.user_id,
              },
            }).then((res) => {
              if (res.status) {
                // alert('Data inserted');
                // console.log('res:', res)
                this.setState((state) => ({
                  btnloading: false,
                  visible: false,
                }));
                // Modal.success({
                //     title: 'Success',
                //     content: "Successfully Updated",
                // });
                notification.success({
                  message: "Success",
                  description: res.message,
                  duration: 10,
                  top: 20,
                  right: 0,
                });
                this.passwordmodalcancel();
                this.logout();
              } else {
                this.setState({ btnloading: false });
                // alert('Data not inserted');
                // console.log('fail res:', res)
                // Modal.error({
                //     title: 'Failure',
                //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
                // });
                notification.error({
                  message: "Failure",
                  description: res.message
                    ? res.message
                    : "Oops! something went wrong... Please try again.",
                  duration: 10,
                  top: 20,
                  right: 0,
                });
              }
            });
          }
        );
      }
      notification.error({
        message: "Failure",
        description: "New password and confirm password are not matching.",
        duration: 10,
        top: 20,
        right: 0,
      });
      let resetpassword = Object.assign({}, resetpasswordSchema);
      resetpassword["feilds"].map((feild, key) => {
        resetpassword["feilds"][key]["value"] = null;
        resetpassword["feilds"][key]["valid"] = false;
        resetpassword["feilds"][key]["errors"] = [];
        delete resetpassword["feilds"][key]["text"];
      });
      this.setState({ resetpassword: resetpassword["feilds"] });
    }
  };

  gotoDasahboard() {
    let user_data = JSON.parse(Storage.get("user_data"))
    let role_id = user_data && user_data["roleid"]
    // Super admin, admin , unit admin
    role_id && (role_id === "RL_ijmN" || role_id === "RL_uxwJ" || role_id==="RL_ifmK" || role_id==="RL_4eOf" ||role_id==="RL_7LBz") &&
    this.props.history.push(`/dashboard`)
    // Technician
    role_id && (role_id === "RL_qjrf") &&
    this.props.history.push(`/queue/technician-view`)
    // Operator
    role_id && (role_id === "RL_dNpj") &&
    this.props.history.push(`/queue/operator-view`)
    // Doctor
    role_id && (role_id === "RL_fGhl") &&
    this.props.history.push(`/queue/doctor-view`)
    // Vitals
    role_id && (role_id === "RL_L4fj") &&
    this.props.history.push(`/queue/vitals-view`)
    // Biller
    role_id && (role_id === "RL_Rco9") &&
    this.props.history.push(`/queue/biller-view`)
    // Token Generator
    role_id && (role_id === "RL_J88m") &&
    this.props.history.push(`/queue/token-generator`)
  }

  logout = () => {
    Storage.clearAll();
    this.props.history.push(`/login`);
  };

  ShowresendWithDelay = () => {
    setTimeout(() => {
      this.setState({ isShow: true });
    }, 60000);
  };

  validateFeilds(event) {
    loginSchema.feilds.filter((feild, fkey) => {
      if (feild["element"] === "input" && feild["name"] === event.name) {
        loginSchema.feilds[fkey].errors = [];
        if (feild["rules"].length > 0) {
          feild["rules"].map((rule, rkey) => {
            if (typeof rule.test === "function") {
              if (event.value !== null && rule.test(event.value)) {
              } else {
                loginSchema.feilds[fkey].errors.push({ message: rule.message });
              }
            }
            if (rule.test instanceof RegExp) {
              if (event.value !== null && rule.test.test(event.value)) {
              } else {
                loginSchema.feilds[fkey].errors.push({ message: rule.message });
              }
            }
          });
          if (feild.errors.length !== 0) {
            this.setState((state) => ({
              [event.name]: event.value,
            }));
            loginSchema.feilds[fkey].valid = false;
          } else {
            this.setState((state) => ({
              [event.name]: event.value,
            }));
            loginSchema.feilds[fkey].valid = true;
          }
        } else {
          this.setState((state) => ({
            [event.name]: event.value,
          }));
          loginSchema.feilds[fkey].valid = true;
        }
      }
    });
  }

  inputChangedState(event) {
    if (event.enter) {
      this.login(event);
    } else {
      this.validateFeilds(event);
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
      otpmodal: false,
      passwordmodal: false,
    });
  };
  otpmodal = () => {
    this.setState({
      visible: false,
      otpmodal: true,
    });
  };
  otpmodalcancel = () => {
    this.setState({
      otpmodal: false,
    });
  };
  passwordmodal = () => {
    this.setState({
      visible: false,
      otpmodal: false,
      passwordmodal: true,
    });
  };
  passwordmodalcancel = () => {
    this.setState({
      passwordmodal: false,
    });
  };
  handleCancel = (e) => {
    // console.log(e)
    this.setState({ visible: false });
  };
  date = () => {
    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var that = this;
    var date = new Date().getDate(); //Current Date
    var month = monthNames[new Date().getMonth()]; //Current Month
    var year = new Date().getFullYear(); //Current Year

    that.setState({
      //Setting the value of the date time
      date: date + " " + month + " " + year,
      year: year,
    });
  };
  handleChange(ele) {
    // console.log(ele);
    if (ele) {
      this.state.formData.map((data, key) => {});
    }
  }

  validateModalFeilds(formFeilds) {
    let errors = [];
    let role_id = null;
    formFeilds.map((feild, key) => {
      if (
        feild["element"] === "input" ||
        feild["element"] === "select2" ||
        feild["element"] === "date"
      ) {
        if (feild["name"] === "role_id" && feild["value"] === "RL_fm8f") {
          role_id = true;
        } else {
          role_id = false;
        }
        formFeilds[key]["errors"] = [];
        if (!feild.disable) {
          feild.rules.map((rule, rkey) => {
            if (
              rule.test !== undefined &&
              typeof rule.test === "function" &&
              !rule.test(feild["value"])
            ) {
              formFeilds[key]["errors"].push({ message: rule.message });
              errors.push(false);
            }
          });
        }
      }
      if (role_id !== null && role_id) {
      }
    });

    this.setState((state) => ({ formData: formFeilds }));
    return errors;
  } 
 returnBadge = () => {
    return (
      <>
        {/* {networkList.base_url !== "https://qms.rainbowhospitals.in:3000/" &&  ( */}
        {networkList.base_url !== "http://localhost:3001/" &&  (
          <span className="badge">
            UAT
          </span>
        )}
      </>
    );
  }
  render() {
    let { formData, formotpData, resetpassword } = this.state;
    return (
      <React.Fragment>
        <div className="new-login-layer">
          <div className="row h-100 m-0 p-5 login-bg">
            <div className="col-xl-4 col-lg-4 col-4 login-card">
            {this.returnBadge()} 
              <img alt="" width="250px" height="70px" src={logo} />
              <form noValidate className="pt-3">
                {loginSchema.feilds.map((feild, key) => {
                  if (feild.element === "label") {
                    return (
                      <div className="mb-3" key={key}>
                        <h5>{feild.text}</h5>
                        <p className="login-para-1">
                          Centralised user authentication system for all 
                          units of Rainbow Hospitals QMS. Your access to features 
                          is controlled by your role.
                        </p>
                      </div>
                    );
                  }
                  if (feild.element === "input") {
                    return (
                      <div className="row mb-3" key={key}>
                        <div className="col-12 mx-auto">
                          <label>{feild.text}</label>
                          <Inputlayer
                            login={"login field"}
                            key={key}
                            id={feild.name}
                            feildData={feild}
                            onInputChanges={this.inputChangedState.bind(this)}
                          />
                        </div>
                      </div>
                    );
                  }
                  if (feild.element === "button") {
                    return (
                      <div className="row" key={key}>
                        <div className="col-12 text-right">
                          <a
                            href="#"
                            // className="text-white text-capitalize forgot-pass"
                            onClick={this.showModal.bind(this)}
                          >
                            Forgot password?
                          </a>
                        </div>
                        <div className="pl-3">
                          <Button
                            onClick={this.login.bind(this)}
                            loading={this.state.loading}
                            id="login"
                            className="login-btn"
                            style={{ backgroundColor: "#6c3964" }}
                          >
                            Login
                          </Button>
                        </div>
                      </div>
                    );
                  }
                })}
              </form>
            </div>
            <div className="col-xl-1 col-lg-1 col-1"></div>
            <div className="col-xl-5 col-lg-5 col-5 pt-5">
              <h6 className="heading">Queue Management System</h6>
              <p className="login-desc" >
                This is advanced queue management system which provides
                convenience to the patients, ease of operations to the staff and
                required analytical reports to the management.
              </p>
            </div>

            <Modal
              visible={this.state.visible}
              onCancel={this.handleCancel}
              footer={null}
            >
              {/* enter username */}
              <div className="text-center token-popup p-5">
                <form noValidate>
                  {formData !== undefined && (
                    <React.Fragment>
                      {formData.map((feild, key) => {
                        if (feild.element === "label") {
                          return (
                            <div className="row mb-3" key={key}>
                              <div className="col-12 mx-auto">
                                <h3 className="text-center">{feild.title}</h3>
                                {/* <small>Enter your username to reset your password.</small> */}
                              </div>
                            </div>
                          );
                        }
                        if (feild.element === "input") {
                          return (
                            <div className="row mb-3" key={key}>
                              <div className="col-12 mx-auto">
                                <label className="data-label w-100 text-left">
                                  {feild.title}
                                </label>
                                <Inputlayer
                                  {...this.props}
                                  {...this.state}
                                  key={key}
                                  feildData={feild}
                                  onInputChanges={this.handleChange.bind(this)}
                                />
                              </div>
                            </div>
                          );
                        }
                      })}
                    </React.Fragment>
                  )}
                  <div className="row justify-content-center pt-3">
                    <Button
                      className="btn btn-success text-capitalize mr-3"
                      onClick={this.sendOTP}
                      loading={this.state.btnloading}
                    >
                      submit
                    </Button>
                    <Button
                      className="btn btn-success btn-next text-capitalize mr-3"
                      onClick={this.handleCancel}
                      loading={this.state.btnloading}
                    >
                      cancel
                    </Button>
                  </div>
                </form>
              </div>
            </Modal>
            <Modal
              visible={this.state.otpmodal}
              onCancel={this.handleCancel}
              footer={null}
            >
              {/* enter otp */}
              <div className="text-center token-popup p-5">
                <form noValidate>
                  {formotpData !== undefined && (
                    <React.Fragment>
                      {formotpData.map((feild, key) => {
                        if (feild.element === "label") {
                          return (
                            <div className="row mb-3" key={key}>
                              <div className="col-12 mx-auto">
                                <h3 className="text-center">
                                  Please enter the OTP we sent to{" "}
                                  {this.state.mobile}
                                </h3>
                              </div>
                            </div>
                          );
                        }
                        if (feild.element === "input") {
                          return (
                            <div className="row mb-3" key={key}>
                              <div className="col-12 mx-auto">
                                <label className="data-label w-100 text-left">
                                  {feild.title}
                                </label>
                                <Inputlayer
                                  {...this.props}
                                  {...this.state}
                                  key={key}
                                  feildData={feild}
                                  onInputChanges={this.handleChange.bind(this)}
                                />
                              </div>
                              <div className="col-12">
                                {this.state.isShow ? (
                                  <a
                                    href="javascript:void(0)"
                                    className="float-right pt-1"
                                    onClick={this.resendOTP}
                                  >
                                    Resend OTP
                                  </a>
                                ) : (
                                  <small className="float-right pt-1">
                                    Resend OTP in {this.state.timer}s
                                  </small>
                                )}
                              </div>
                            </div>
                          );
                        }
                      })}
                    </React.Fragment>
                  )}
                  <div className="row justify-content-center pt-2">
                    <Button
                      className="btn btn-success text-capitalize mr-3"
                      onClick={this.checkOTP}
                      loading={this.state.btnloading}
                    >
                      verify
                    </Button>
                    <Button
                      className="btn btn-success btn-next text-capitalize mr-3"
                      onClick={this.otpmodalcancel}
                      loading={this.state.btnloading}
                    >
                      cancel
                    </Button>
                  </div>
                </form>
              </div>
            </Modal>
            <Modal
              visible={this.state.passwordmodal}
              onCancel={this.handleCancel}
              footer={null}
            >
              {/* reset password */}
              <div className="text-center token-popup p-5">
                <form noValidate>
                  {resetpassword !== undefined && (
                    <React.Fragment>
                      {resetpassword.map((feild, key) => {
                        if (feild.element === "label") {
                          return (
                            <div className="row mb-3" key={key}>
                              <div className="col-12 mx-auto">
                                <h3 className="text-center">{feild.text}</h3>
                              </div>
                            </div>
                          );
                        }
                        if (feild.element === "input") {
                          return (
                            <div className="row mb-3" key={key}>
                              <div className="col-12 mx-auto">
                                <label className="data-label w-100 text-left">
                                  {feild.title}
                                </label>
                                <Inputlayer
                                  {...this.props}
                                  {...this.state}
                                  key={key}
                                  feildData={feild}
                                  onInputChanges={this.inputChangedState.bind(
                                    this
                                  )}
                                />
                              </div>
                            </div>
                          );
                        }
                      })}
                    </React.Fragment>
                  )}
                  <div className="row justify-content-center pt-3">
                    <Button
                      className="btn btn-success text-capitalize mr-3"
                      onClick={this.updatePassword}
                      loading={this.state.btnloading}
                    >
                      Submit
                    </Button>
                    <Button
                      className="btn btn-success btn-next text-capitalize mr-3"
                      onClick={this.passwordmodalcancel}
                      loading={this.state.btnloading}
                    >
                      cancel
                    </Button>
                  </div>
                </form>
              </div>
            </Modal>

            <Footer />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default jwt(Login);
